/**
 * Formate une date ISO en DD/MM/YYYY sans conversion de timezone.
 * Utile pour les dates pures (périodes, reporting) qui ne doivent pas
 * être converties en heure locale.
 *
 * @param isoDate - Date au format ISO string ou objet Date
 * @returns Date formatée en DD/MM/YYYY ou "—" si invalide
 */
export const formatDateOnly = (isoDate: string | Date): string => {
	if (!isoDate) return '—';
	const dateStr = typeof isoDate === 'string' ? isoDate : isoDate.toISOString();
	const [year, month, day] = dateStr.split('T')[0].split('-');
	return `${day}/${month}/${year}`;
};

const DAY_MS = 24 * 60 * 60 * 1000;

/**
 * Nombre de jours écoulés depuis une date, pour afficher une ancienneté
 * ("suspendu depuis 6 j", "en retard de 23 j").
 *
 * @param isoDate - Date au format ISO string ou objet Date
 * @returns Nombre de jours entiers, 0 si la date est dans le futur,
 *          null si la date est absente
 */
export const daysSince = (isoDate?: string | Date | null): number | null => {
	if (!isoDate) return null;
	const elapsed = Date.now() - new Date(isoDate).getTime();
	if (Number.isNaN(elapsed)) return null;
	return elapsed < 0 ? 0 : Math.floor(elapsed / DAY_MS);
};
